import { observer } from 'mobx-react-lite'
import { Button, FullPageWrapper, SpinnerLoader, Typography } from 'shared/ui'
import { createCustomFieldAction } from 'entities/CustomField'
import {
  CustomFieldsProvider,
  useCustomFieldsContext,
} from 'pages/settings/pages/customFields/context/customFieldsContext'
import { CustomFieldsTable } from 'pages/settings/pages/customFields/ui/CustomFieldsTable/CustomFieldsTable'
import styles from './styles.module.scss'

const CustomFieldsContent = observer(() => {
  const { initialLoading, loadCustomFields } = useCustomFieldsContext()

  if (initialLoading) return <SpinnerLoader ariaLabel={'CustomFieldsPage'} />

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerDetails}>
          <Typography variant='heading-lg' ariaLabel='Custom Fields header'>
            Custom Fields
          </Typography>
          <Typography
            variant='body-md-regular'
            ariaLabel='Custom Fields description'
            color='tertiary'
          >
            Use fields to capture contact information
          </Typography>
        </div>
        <Button
          text='New field'
          iconProps={{ icon: 'add' }}
          size='medium'
          onClick={() => createCustomFieldAction(loadCustomFields)}
        />
      </header>

      <CustomFieldsTable />
    </div>
  )
})

export const CustomFieldsPage = observer(() => (
  <FullPageWrapper>
    <CustomFieldsProvider>
      <CustomFieldsContent />
    </CustomFieldsProvider>
  </FullPageWrapper>
))
